/* Case Planet - buy buttons
   Left button reads "Add to cart" with the live price. Click = add to cart (with the chosen spinner colour), then the cart opens.
   Fastrr's block sits below it. No model chosen = shake + popup.
   The floating "Add to cart" pill is removed: the theme's sticky bar is the only bottom button.
*/
(function () {
  var SEL = '[data-cp-add], button[name="add"], form[action*="/cart/add"] button[type="submit"],' +
            '.cp-buy__cta, .cp-btn--block, .cp-buy button.cp-btn';
  var BASE = 'Add to cart';
  var CART_URL = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  var modal = null, lock = false, placed = false, opening = false;

  (function css() {
    var s = document.createElement('style');
    s.textContent =
      '.cp-buyrow{display:flex !important;flex-direction:column !important;align-items:stretch !important;gap:8px;width:100%}' +
      '.cp-buyrow > *{flex:0 0 auto !important;width:100% !important;max-width:100% !important;min-width:0;margin:0 !important;box-sizing:border-box}' +
      '.cp-buyrow > .cp-btn,.cp-buyrow > [data-cp-add]{display:flex !important;align-items:center;justify-content:center;text-align:center;white-space:nowrap}' +
      '.cp-buyrow [data-cp-fastrr]:empty{display:none !important}' +
      '.cp-buyrow [data-cp-fastrr]{display:block !important;margin:0 !important}' +
      '.cp-buyrow .shiprocket-headless{width:100%}' +
      '.cp-buyrow .sr-headless-checkout{width:100% !important;height:58px !important;margin:0 !important}' +
      '@media (max-width:480px){.cp-buyrow .sr-headless-checkout{height:54px !important}}' +
      '.cp-cta-gold{background:linear-gradient(180deg,#F2CF6B,#D9A93F) !important;color:#000 !important;' +
      'border:0 !important;font-weight:900 !important;border-radius:999px !important;' +
      'box-shadow:0 8px 22px rgba(217,169,63,.32),inset 0 1px 0 rgba(255,255,255,.45) !important;' +
      'transition:transform .14s ease,filter .2s ease}' +
      '.cp-cta-gold *{color:#000 !important}' +
      '.cp-cta-gold:active{transform:translateY(2px)}' +
      '.cp-cta-gold.is-busy{filter:brightness(.85);pointer-events:none}' +
      '@keyframes cpShake{0%,100%{transform:translateX(0)}12%{transform:translateX(-9px)}' +
      '26%{transform:translateX(8px)}40%{transform:translateX(-6px)}54%{transform:translateX(5px)}' +
      '70%{transform:translateX(-3px)}85%{transform:translateX(2px)}}' +
      '.cp-shake{animation:cpShake .55s ease}' +
      '.cp-modal{position:fixed;inset:0;z-index:2147483000;display:none;place-items:center;padding:20px;' +
      'background:rgba(0,0,0,.66);backdrop-filter:blur(4px)}' +
      '.cp-modal.is-on{display:grid}' +
      '.cp-modal__card{width:100%;max-width:340px;border-radius:20px;padding:26px 22px 20px;' +
      'background:#141416;border:1px solid rgba(255,255,255,.1);text-align:center;color:#fff}' +
      '.cp-modal__ico{width:52px;height:52px;margin:0 auto 14px;border-radius:50%;display:grid;' +
      'place-items:center;background:rgba(226,184,77,.16);font-size:24px}' +
      '.cp-modal__card h3{margin:0 0 6px;font-family:Manrope,sans-serif;font-weight:800;font-size:19px;color:#fff}' +
      '.cp-modal__card p{margin:0 0 18px;font-size:14px;line-height:1.5;color:rgba(255,255,255,.66)}' +
      '.cp-modal__btn{width:100%;height:50px;border:0;border-radius:999px;cursor:pointer;' +
      'background:linear-gradient(180deg,#F2CF6B,#D9A93F);color:#000;font-weight:900;font-size:15px}';
    document.head.appendChild(s);
  })();

  function cta() { return document.querySelector(SEL); }
  function slot() { return document.querySelector('[data-cp-fastrr]'); }
  function buyBox() { return document.querySelector('.cp-buy') || document.getElementById('cp-shop'); }
  function picker() {
    return document.querySelector('.cp-picker, [data-cp-picker], [data-cp-model], .cp-buy__picker') || buyBox();
  }
  function priceIn(t) { var m = (t || '').match(/(Rs\.?|₹)\s?[\d,]+(\.\d+)?/); return m ? m[0] : ''; }
  function price() {
    var el = document.querySelector('[data-cp-price], .cp-buy__price, .cp-price');
    return priceIn(el ? el.textContent : '') || priceIn((cta() || {}).textContent);
  }
  function chosen() {
    var h = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (h && h.value && h.value !== '0') return true;
    var sel = document.querySelector('.cp-buy select');
    if (sel && sel.value && sel.selectedIndex > 0) return true;
    if (document.querySelector('.cp-picker__opt.is-selected, [data-cp-model].is-selected, [aria-selected="true"]')) return true;
    return false;
  }

  function place() {
    var b = cta(), sl = slot();
    if (!b || !sl) return;
    if (placed && b.parentNode && b.parentNode.classList.contains('cp-buyrow')) { sl.hidden = false; return; }
    var row = document.createElement('div');
    row.className = 'cp-buyrow';
    b.parentNode.insertBefore(row, b);
    row.appendChild(b);
    row.appendChild(sl);
    sl.hidden = false;
    placed = true;
  }

  function applyLabel() {
    var b = cta();
    if (!b || lock) return;
    b.classList.add('cp-cta-gold');
    var p = price();
    var want = p ? (BASE + ' — ' + p) : BASE;
    if (b.textContent.replace(/\s+/g, ' ').trim() !== want) {
      lock = true; b.textContent = want; lock = false;
    }
  }

  function observe() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () { place(); applyLabel(); })
      .observe(buyBox() || document.body, { childList: true, subtree: true, characterData: true });
  }

  function buildModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'cp-modal';
    modal.innerHTML =
      '<div class="cp-modal__card" role="dialog" aria-modal="true">' +
      '<div class="cp-modal__ico">📱</div>' +
      '<h3>Choose your mobile model first</h3>' +
      '<p>Pick your phone brand and model so we send the case that fits.</p>' +
      '<button type="button" class="cp-modal__btn">Choose my model</button></div>';
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('.cp-modal__btn')) {
        modal.classList.remove('is-on');
        var p = picker();
        if (p) p.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal) modal.classList.remove('is-on');
    });
    document.body.appendChild(modal);
    return modal;
  }
  function refuse(btn) {
    btn = btn || cta();
    if (btn) {
      btn.classList.remove('cp-shake'); void btn.offsetWidth; btn.classList.add('cp-shake');
      setTimeout(function () { btn.classList.remove('cp-shake'); }, 650);
    }
    if (navigator.vibrate) { try { navigator.vibrate([40, 60, 40]); } catch (e) {} }
    buildModal().classList.add('is-on');
  }

  /* Add the chosen model straight to the cart, then open the cart (the theme's slide-in cart page). */
  var ADD_SEL = '[data-cp-add], button[name="add"], form[action*="/cart/add"] button[type="submit"]';
  function variantId() {
    var h = document.querySelector('form[data-cp-primary] input[name="id"]') ||
            document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return h && h.value && h.value !== '0' ? h.value : '';
  }
  function showError(text) {
    var m = document.querySelector('form[data-cp-primary] [data-cp-msg]') || document.querySelector('[data-cp-msg]');
    if (m) { m.textContent = text; m.hidden = false; } else { alert(text); }
  }
  function addAndOpen(btn) {
    if (opening) return;
    var id = variantId();
    if (!id) { refuse(btn || cta()); return; }
    opening = true;
    btn = btn || cta();
    if (btn) btn.classList.add('is-busy');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var item = { id: Number(id), quantity: 1 };
    if (document.querySelector('[data-cp-colour-picker]')) {
      item.properties = { 'Spinner colour': window.__cpColour || 'Black' };
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart. Please try again.');
        window.location.href = CART_URL;
      });
    }).catch(function (err) {
      opening = false;
      if (btn) btn.classList.remove('is-busy');
      showError(err.message || 'Could not add to cart. Please try again.');
    });
  }

  document.addEventListener('click', function (e) {
    var inSr = e.target.closest('[data-cp-fastrr]');
    var b = e.target.closest(SEL);
    if (!b && !inSr) return;
    if (!chosen()) {
      e.preventDefault(); e.stopImmediatePropagation();
      refuse(b || cta());
      return;
    }
    // Model chosen + our Add to cart button: add it ourselves and open the cart.
    if (b && b.matches(ADD_SEL)) {
      e.preventDefault(); e.stopImmediatePropagation();
      addAndOpen(b);
    }
  }, true);

  // Pressing Enter inside the picker also submits the form: route it the same way.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    if (!variantId()) return;
    e.preventDefault(); e.stopImmediatePropagation();
    addAndOpen(cta());
  }, true);

  function boot() {
    place(); applyLabel(); observe();
    var n = 0;
    var t = setInterval(function () {
      place();
      applyLabel();
      if (++n > 24) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', function () { place(); applyLabel(); });
})();